import styled from "styled-components";

export default styled.div`
  padding: 0 32px;
  line-height: 60px;
  &:first-letter {
    text-transform: uppercase;
  }
`;
